/**
 * <p>Adds a query string to the provided URL using the params object</p>
 * <p>e.g. Input => URL: www.sample.com, params = {userId: 56, name: "Jonas"}</p>
 *      Output => www.sample.com?userId=56&name=Jonas
 * @param url The url that will contain the query string
 * @param params The object that will be transformed into a query string
 * @return A new url instance containing the query string
 * */
export const appendQueryString = (url: URL, params: Record<string, any> = {}): URL => {
    if (Object.keys(params).length === 0)
        throw "The params object can't be empty";

    const urlWithQueryString = new URL(url)
    for (const key in params)
        urlWithQueryString.searchParams.append(key, `${params[key]}`)

    return urlWithQueryString;
}


